import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenBundleCarouselComponent } from './bundle-carousel.component';
import { ConfigModule, I18nModule, provideConfig } from "@spartacus/core";
import { IconModule, SpinnerModule } from "@spartacus/storefront";
import { translationsEn } from "@spartacus/assets";
import { BundleSlideModule, productTranslationChunksConfig } from "../../shared/components/bundle-slide/bundle-slide.module";

@NgModule({
  declarations: [
    GenBundleCarouselComponent
  ],
  imports: [
    CommonModule,
    BundleSlideModule,
    I18nModule,
    IconModule,
    SpinnerModule,
    ConfigModule,
  ],
  exports: [
    GenBundleCarouselComponent,
  ],
  providers:[
    provideConfig({
      i18n: {
        resources: {
          en: translationsEn
        },
        chunks: productTranslationChunksConfig
      }
    })
  ]
})
export class BundleCarouselModule { }
